import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import AuthService from '../services/auth.service';

// Component to redirect to dashboard if already authenticated
const RedirectIfAuthenticated: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validateAuth = async () => {
            try {
                const isValid = await AuthService.validateSession();
                if (isValid) {
                    navigate('/dashboard?redirect=easywebinar');
                }
            } catch (error) {
                // Silently handle validation errors
                console.log('Session validation error:', error);
            } finally {
                setLoading(false);
            }
        };
        
        // Only validate if we're not coming from a redirect
        const currentPath = location.pathname;
        const isAuthPage = currentPath === '/login' || currentPath === '/signup';
        const fromRedirect = isAuthPage && document.referrer.includes(window.location.origin + '/');
        
        if (!fromRedirect) {
            validateAuth();
        } else {
            setLoading(false);
        }
    }, [navigate, location.pathname]);

    if (loading) {
        // You could add a loading spinner here if needed
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}></div>;
    }

    return <>{children}</>;
};

export default RedirectIfAuthenticated; 